(() => {
  const countSelector = '.cart-count';

  const renderCount = (count) => {
    const safeCount = Number.isFinite(Number(count)) ? Math.max(0, Number(count)) : 0;

    document.querySelectorAll(countSelector).forEach((badge) => {
      badge.textContent = String(safeCount);
      badge.hidden = false;
      badge.removeAttribute('aria-hidden');
      badge.setAttribute('aria-label', `${safeCount} Artikel im Warenkorb`);
    });
  };

  const fetchCart = async () => {
    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      const cart = await response.json();
      renderCount(cart.item_count);
      return cart;
    } catch (error) {
      console.warn('[MSP cart count] Shopify cart could not be loaded.', error);
      return null;
    }
  };

  const handleShopifyCartUpdate = (event) => {
    const itemCount = event?.cartData?.item_count;
    if (itemCount !== undefined && itemCount !== null) {
      renderCount(itemCount);
      return;
    }
    fetchCart();
  };

  const initialize = () => {
    fetchCart();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, handleShopifyCartUpdate);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.addEventListener('pageshow', fetchCart);
  window.addEventListener('focus', fetchCart);
  window.addEventListener('cartUpdated', fetchCart);
  document.addEventListener('msp:cart-refresh', fetchCart);
})();
